module.exports = __webpack_public_path__ + "static/nosBG-db889627cec4e1256dd69aae7da11544.jpg";